import { AcknowledgmentAction } from 'legacy/lut/components/widgets/public/partner360/commitment/enums/AckonwledgmentAction'
import {
  IRequestAcknowledgementParameters,
  requestAcknowledgement,
} from 'legacy/lut/features/partner360/commitment'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'

interface IUsePBMActions {
  ackPartialInfo: IObjectAny
  checkContactIsUnique: (email: string) => boolean
}

export const usePBMActions = ({ ackPartialInfo, checkContactIsUnique }: IUsePBMActions) => {
  const [showSelectPBMModal, setShowSelectPBMModal] = useState(false)
  const dispatch = useAppDispatch()

  const callAcknowledgmentAction = useCallback(
    (parameters: IRequestAcknowledgementParameters) => {
      return dispatch(requestAcknowledgement(parameters))
    },
    [dispatch]
  )

  const openPMBSelectModal = useCallback(() => {
    setShowSelectPBMModal(true)
  }, [])

  const closePMBSelectModal = useCallback(() => {
    setShowSelectPBMModal(false)
  }, [])

  const addPBM = useCallback(
    async (data: any) => {
      if (!checkContactIsUnique(data.Email || data.ManagerEmail)) {
        return
      }
      // setIsLoaded(false)
      if (ackPartialInfo) {
        await callAcknowledgmentAction({
          partnerId: ackPartialInfo.PartnerId,
          fYear: ackPartialInfo.FYear,
          programType: ackPartialInfo.ProgramType,
          entryId: ackPartialInfo.EntryId,
          actionData: {
            Action: AcknowledgmentAction.Add,
            Email: data.Email || data.ManagerEmail,
            FirstName: data.FirstName || data.ManagerFirstName,
            LastName: data.LastName || data.ManagerLastName,
            CommitmentType: ackPartialInfo.CommitmentType,
            Role: data.Roles,
          },
        })
      }
      // setIsLoaded(true)
      closePMBSelectModal()
    },
    [checkContactIsUnique, closePMBSelectModal, ackPartialInfo, callAcknowledgmentAction]
  )

  return { showSelectPBMModal, openPMBSelectModal, addPBM, closePMBSelectModal }
}
